import { Link } from "react-router-dom";
import { homePage } from "@/mocks/home";
import ScrollReveal from "@/components/feature/ScrollReveal";

export default function HomeNews() {
  const { news } = homePage;
  return (
    <ScrollReveal delay={100}>
      <section className="py-16 md:py-20 bg-redbean-lightcream">
        <div className="mx-auto px-4 md:px-6 lg:px-8" style={{ maxWidth: "1200px" }}>
          <div className="flex items-center justify-between mb-10 md:mb-12">
            <h2
              className="font-heading font-bold text-redbean-coffee"
              style={{ fontSize: "clamp(1.5rem, 3vw, 2.125rem)", lineHeight: 1.4 }}
            >
              {news.title}
            </h2>
            <Link
              to="/news"
              className="hidden md:inline-flex items-center gap-1 text-redbean-caramel font-medium text-[1rem] hover:text-redbean-primary transition-colors"
            >
              {news.viewAll}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {news.articles.map((article, idx) => (
              <ScrollReveal key={idx} delay={idx * 120}>
                <div
                  className="bg-white rounded-card p-6 shadow-soft hover:shadow-card transition-shadow duration-300 group"
                >
                  <span className="inline-block px-3 py-1 bg-redbean-gold/20 text-redbean-coffee text-xs font-semibold rounded-full mb-4">
                    {article.tag}
                  </span>
                  <h3
                    className="font-heading font-bold text-redbean-coffee mb-2 group-hover:text-redbean-primary transition-colors"
                    style={{ fontSize: "1.25rem", lineHeight: 1.5 }}
                  >
                    {article.title}
                  </h3>
                  <span className="text-redbean-coffee/40 text-sm mb-3 block">{article.date}</span>
                  <p className="text-redbean-coffee/60 text-[1rem] leading-relaxed mb-4">
                    {article.summary}
                  </p>
                  <span className="inline-flex items-center gap-1 text-redbean-caramel text-sm font-medium hover:text-redbean-primary transition-colors cursor-pointer">
                    閱讀更多
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line" />
                    </span>
                  </span>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <div className="text-center mt-8 md:hidden">
            <Link
              to="/news"
              className="inline-flex items-center gap-1 text-redbean-caramel font-medium text-[1rem]"
            >
              {news.viewAll}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
}